import { componentVariant } from '../../../internal/styles/componentVariant';
import type { Theme } from '../../../themes/types';

const invertedTypeVariant = ({ theme }: { theme: Theme }) => {
  return componentVariant({
    prop: 'variant',
    variants: {
      primary: {
        color: 'button.primary.inverted.color',
        bg: 'button.primary.inverted.bgColor',
        border: 'unset',

        '@media (hover: hover)': {
          ':hover:not(:disabled)': {
            bg: 'button.primary.inverted.hover.bgColor',
          },
        },
        ':active': {
          bg: 'button.primary.inverted.active.bgColor',
        },
        ':focus': {},
        ':disabled': {
          bg: 'button.primary.inverted.disabled.bgColor',
          color: 'button.primary.inverted.disabled.color',
        },
      },
      secondary: {
        color: 'button.secondary.inverted.color',
        bg: 'transparent',
        boxShadow: `inset 0 0 0 1.5px ${theme.colors.neutral['0']}`,
        '@media (hover: hover)': {
          ':hover:not(:disabled)': {
            bg: 'transparent',
            color: 'button.secondary.inverted.color',
            boxShadow: `inset 0 0 0 1.5px ${theme.colors.neutral['0']}`,
            opacity: '0.68',
          },
        },
        ':active': {
          bg: 'transparent',
          color: 'button.secondary.inverted.color',
          borderColor: 'button.secondary.inverted.color',
          boxShadow: `inset 0 0 0 1.5px ${theme.colors.neutral['0']}`,
          opacity: '0.68',
        },
        ':disabled': {
          bg: 'transparent',
          color: 'button.secondary.inverted.disabled.color',
          borderColor: 'button.secondary.disabled.inverted.color',
          boxShadow: `inset 0 0 0 1.5px ${theme.colors.neutral['30']}`,
        },
      },
      /**
       * @deprecated
       * no text button on cobalt design system
       * */
      text: {
        color: 'button.text.inverted.color',
        bg: 'transparent',
        borderColor: 'transparent',
        '@media (hover: hover)': {
          ':hover:not(:disabled)': {
            color: 'button.text.inverted.hover.color',
            bg: `${theme.colors.neutral['0']}33`,
          },
        },
        ':active:not(:disabled)': {
          color: 'button.text.inverted.color',
          bg: 'transparent',
        },
        ':disabled': {
          color: 'button.text.inverted.disabled.color',
        },
      },
      positive: {
        color: 'positive.50',
        backgroundColor: 'transparent',
        '@media (hover: hover)': {
          ':hover:not(:disabled)': {
            color: 'positive.70',
          },
        },
        ':active:not(:disabled)': {
          color: 'positive.70',
        },
        ':disabled': {
          backgroundColor: 'neutral.30',
          color: 'neutral.50',
        },
      },
      warning: {
        color: 'warning.50',
        backgroundColor: 'transparent',
        '@media (hover: hover)': {
          ':hover:not(:disabled)': {
            color: 'warning.70',
          },
        },
        ':active:not(:disabled)': {
          color: 'warning.70',
        },
        ':disabled': {
          backgroundColor: 'neutral.30',
          color: 'neutral.50',
        },
      },
      critical: {
        color: 'critical.50',
        backgroundColor: 'transparent',
        '@media (hover: hover)': {
          ':hover:not(:disabled)': {
            color: 'critical.70',
          },
        },
        ':active:not(:disabled)': {
          color: 'critical.70',
        },
        ':disabled': {
          backgroundColor: 'neutral.30',
          color: 'neutral.50',
        },
      },
      deal: {
        color: 'neutral.0',
        backgroundColor: 'deals.50',
      },
    },
  });
};

export default invertedTypeVariant;
